import { render, staticRenderFns } from "./SchoolSvg.vue?vue&type=template&id=515f1df0&"
import script from "./SchoolSvg.vue?vue&type=script&lang=js&"
export * from "./SchoolSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports